export const FontFamilyName = 'Roboto';
export const FontFamily = FontFamilyName + ', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
export const FontSize = '16px';
export const FontWeight = '400';
export const FontWeightBold = '500';
export const FontFull = `${FontWeight} ${FontSize} ${FontFamily}`;
export const FontFullBold = `${FontWeightBold} ${FontSize} ${FontFamily}`;
